import { AxiosResponse } from 'axios';

import BaseApi from './BaseApi';

import { StatementData } from 'models';

class OverviewApi extends BaseApi {
	constructor() {
		super('/investor/overview');
	}

	getProfit({ from, to, interval }: StatementData): Promise<AxiosResponse<unknown>> {
		return this.httpClient.get({
			url: `/profit/${from}/${to}/${interval}`,
			conditions: { auth: true },
		});
	}

	getSecondaryMarketProfit({ from, to, interval }: StatementData): Promise<AxiosResponse<unknown>> {
		return this.httpClient.get({
			url: `/secondary-market/profit/${from}/${to}/${interval}`,
			conditions: { auth: true, version: 'v2' },
		});
	}

	get(): Promise<AxiosResponse<unknown>> {
		return this.httpClient.get({ conditions: { auth: true } });
	}

	getInvestmentStatistic(
		type: 'investment_statuses' | 'investment_types' | 'countries' | 'interest-rates',
	): Promise<AxiosResponse<unknown>> {
		return this.httpClient.get({ url: `/${type}`, conditions: { auth: true } });
	}
}

export const OverviewService = new OverviewApi();
